import { render, staticRenderFns } from "./FormViewItem.vue?vue&type=template&id=2ef4d218&"
import script from "./FormViewItem.vue?vue&type=script&lang=js&"
export * from "./FormViewItem.vue?vue&type=script&lang=js&"
import style0 from "./FormViewItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports